import React, { useEffect } from "react";
import { useForm } from 'react-hook-form';
import RFG from "../../libs/inputs/RFG";
import { Box, Typography, Button, Grid, Paper, Card } from "@mui/material";
import CountryList from 'country-list-with-dial-code-and-flag'
import ReactCountryFlag from "react-country-flag"
import CountrySelect from "../extra/CountrySelect";

export default function LiveCamForm({
  title,
  companies = [],
  projects = [],
  brands = [],
  defaultValues = {},
  onSubmit = () => { },
  onChange = () => { },
  back = () => { }
}) {
  const { handleSubmit, control, watch, setValue, clearErrors } = useForm({ defaultValues, mode: "all" });
  const companyVal = watch("company");
  const prevCompanyRef = React.useRef();

  React.useEffect(() => {
    if (companyVal && companyVal !== prevCompanyRef.current) {
      prevCompanyRef.current = companyVal;
      onChange("company", companyVal);
    }
  }, [companyVal, onChange]);

  const booleanFields = [
    { name: "allow_recording", label: "Allow Recording", watch: watch("allow_recording") },
    { name: "active", label: "Active", watch: watch("active") },
    { name: "ptz", label: "PTZ", watch: watch("ptz") },
  ];
  const isNetworkTimelapse = watch("network_timelapse");

  // 🔹 Clear the value when checkbox is unchecked
  // useEffect(() => {
  //   if (!isNetworkTimelapse) {
  //     setValue("auto_timelapse_schedule_in_days", "");
  //   }
  // }, [isNetworkTimelapse, setValue]);


  return (

    <Box sx={{ p: 3 }} >
      <Box className="shadow rounded" sx={{ p: 2, borderRadius: 6 }}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: 6 }}>
              <RFG name="camera_name" label="Name" control={control} rules={{
                required: true, maxLength: 100,
                pattern: {
                  value: /^[A-Za-z0-9\s\-_.]+$/,
                  message: "Invalid camera name. Allowed: letters, numbers, spaces, - _ .",
                },
                maxLength: {
                  value: 100,
                  message: `Cannot exceed 100 characters`,
                }
              }}>
                <input autoComplete="off" placeholder="Camera Name" />
              </RFG>
              <RFG name="company" label="Company" control={control} rules={{ required: true }}>
                <select>
                  <option value="">Select Company</option>
                  {companies.map((c) => <option key={c.id} value={c.id}>{c.company_name}</option>)}
                </select>
              </RFG>
              <RFG name="project" label="Project Name" control={control} rules={{ required: true }}>
                <select>
                  <option value="">Select Project</option>
                  {projects.map((p) => <option key={p.id} value={p.id}>{p.project_name}</option>)}
                </select>
              </RFG>
              <RFG name="brand" label="Camera Brand" control={control} rules={{ required: true }}>
                <select>
                  <option value="">Select Brand</option>
                  {brands.map((b) => <option key={b.id} value={b.id}>{b.brand_name}</option>)}
                </select>
              </RFG>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Box width={200}>
                  <RFG name="protocol" label="Protocol" control={control} rules={{ required: true }}>
                    <select>
                      <option value="">Select Protocol</option>
                      <option value="http://">HTTP</option>
                      <option value="https://">HTTPS</option>
                    </select>
                  </RFG>
                </Box>
                <Box width={1}>
                  <RFG name="ip_address" label="Camera Domain URL or IP Address" control={control} rules={{
                    required: true,
                    pattern: {
                      value: /^(https?:\/\/)?((([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,})|((25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}))(:\d+)?(\/.*)?$/,
                      message: "Enter a valid IP address or domain URL"
                    }
                  }}>
                    <input autoComplete="off" placeholder="Camera Domain URL" />
                  </RFG>
                </Box>
              </Box>
              <RFG name="username" label="Username" control={control} rules={{
                pattern: {
                  value: /^[a-zA-Z0-9._@!$-]+$/,
                  message: "Invalid username. Allowed: letters, numbers, . _ - @ ! $",
                },

              }}>
                <input autoComplete="off" placeholder="Username" />
              </RFG>
              <RFG name="password" label="Password" control={control} >
                <input autoComplete="off" placeholder="Password" />
              </RFG>
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
              <RFG name="scroll_text" label="Scroll text" control={control} rules={{
                maxLength: 100,
                pattern: {
                  value: /^[A-Za-z0-9._\-\s]*$/,
                  message: "Allowed: letters, numbers, spaces, - _ .",
                },
                maxLength: {
                  value: 100,
                  message: `Cannot exceed 100 characters`,
                }
              }} className="mb-2">
                <input autoComplete="false" placeholder="Scroll text" />
              </RFG>
              <RFG name="coordinates" label="Coordinates" control={control} rules={{
                required: true,
                pattern: {
                  value: /^-?(?:[0-8]?\d(?:\.\d{1,35})?|90(?:\.0{1,35})?)\s*,\s*-?(?:180(?:\.0{1,35})?|(?:1[0-7]\d|\d{1,2})(?:\.\d{1,35})?)$/,
                  message: "Invalid coordinates. Use format: latitude,longitude (e.g., -33.86880000,151.20930000)"
                }
              }}>
                <input autoComplete="off" placeholder="e.g. 33.868800,151.209300" />
              </RFG>
              {/* <RFG name="country" label="Country" control={control} rules={{ required: true }}>
              <input autoComplete="off" />
            </RFG> */}
              <Box>
                <RFG
                  name="country"
                  label="Country"
                  control={control}
                  rules={{ required: true, }}
                >
                  <CountrySelect
                    defaultValue={defaultValues.country}
                    labelKey="name"
                    valueKey="code"
                    // onValueChange={(country) => setValue("country", country.value)}
                    onValueChange={(country) => {
                      // Set and validate the same field name
                      const cnty_name = country?.label || "";
                      setValue("country_name", cnty_name);
                      const value = country?.value || "";
                      setValue("country", value, { shouldValidate: true });
                      if (value) clearErrors("country");
                      // no setError here; RHF required rule shows the message on submit
                    }}
                  />
                </RFG>
              </Box>
              <RFG name="video_retention" label="Video Retention in no. of days" control={control} rules={{
                required: true,
                pattern: {
                  value: /^[0-9]{1,3}$/,
                  message: "Days must be in digits",
                },
                maxLength: {
                  value: 3,
                  message: `Cannot exceed 3 digits`
                }
              }}>
                <input autoComplete="off" placeholder="Video Retention in days" />
              </RFG>
              <RFG name="image_retention" label="Image Retention (days)" control={control} rules={{
                pattern: {
                  value: /^[0-9]{1,3}$/,
                  message: "Days must be in digits",
                },
                maxLength: {
                  value: 3,
                  message: `Cannot exceed 3 digits`

                }
              }}>
                <input autoComplete="off" placeholder="Image Retention in days" />
              </RFG>
              <Box display={'flex'} sx={{ my: 2 }}>
                <RFG name="network_timelapse" label="Network Timelapse?" control={control}>
                  <input type="checkbox" onChange={(e) => setValue("network_timelapse", e.target.checked)}
                    checked={watch("network_timelapse")} />
                </RFG>
              </Box>
              {watch("network_timelapse") && (
                <>
                  <RFG name="image_upload_intervals" label="Image Upload Interval" control={control} rules={{
                    required: true,
                    pattern: {
                      value: /^[0-9]{1,3}$/,
                      message: "Days must be in digits",
                    },
                    maxLength: {
                      value: 3,
                      message: `Cannot exceed 3 digits`

                    }
                  }}>
                    <input autoComplete="off" placeholder="Image capture time interval" />
                  </RFG>
                  <RFG name="auto_timelapse_schedule_in_days" label="Auto Timelapse Schedule in days" control={control} rules={{ required: true }} className="mb-2">
                    <select>
                      <option value="">Select Days</option>
                      <option value="1">Past Day</option>
                      <option value="7">Past 7 Days</option>
                      <option value="30">Past 30 Days</option>
                    </select>
                  </RFG>

                </>
              )}

              <Box sx={{ my: 1, px: 1 }} display="flex" flexWrap="wrap" gap={2}>
                {booleanFields.map(({ name, label, watch }) => (
                  <RFG name={name} label={label} control={control} className="mb-2">
                    <input
                      type="checkbox"
                      onChange={(e) => setValue(name, e.target.checked)}
                      checked={watch}
                    />
                  </RFG>
                ))}
              </Box>
              <Box textAlign="right" sx={{ my: 4 }}>
                <Button className="btn-primary" sx={{ mx: 2 }} onClick={back}>
                  Back
                </Button>
                <Button sx={{ mx: 2 }} className="btn-primary" type="submit">Save</Button>
              </Box>
            </Grid>
          </Grid>
        </form>
      </Box>
    </Box>

  );
}
